import React from 'react'
import { articleMetaInfo } from '../styles/single.module.scss'

export default function ArticleInfo({ data }) {
  return (
    <ul className={articleMetaInfo}>
      <li>
        <time dateTime={data.publishDate}>{data.publishDate}</time>
      </li>
    </ul>
  )
}
